export default __webpack_public_path__ + "static/media/comp.cf38362a.svg";